import { Map } from 'immutable';
import { actionTypes as CreateAlertDeviceDialogActionsType } from '../../../actions/Administration/RfidSettingsPage/Dialogs/createAlertDeviceDialogActions.js';

let defaultState = {
  show: false,
  loading: false,
  itemToEdit: null,
  dialogData: null,
};

export default function(state = Map(defaultState), action) {

  switch (action.type) {
    case CreateAlertDeviceDialogActionsType.CREATE_ALERT_DEVICE_DIALOG_SHOW:
      state = state.set('itemToEdit', action.payload);
      return state.set('show',true);

    case CreateAlertDeviceDialogActionsType.CREATE_ALERT_DEVICE_DIALOG_HIDE:
      return Map(defaultState);

    case CreateAlertDeviceDialogActionsType.CREATE_ALERT_DEVICE_DIALOG_SUBMIT_IN_PROGRESS:
      return state.set("loading", true);

    case CreateAlertDeviceDialogActionsType.CREATE_ALERT_DEVICE_DIALOG_SUBMIT_FINISHED:
      return state.set("loading", false);

    case CreateAlertDeviceDialogActionsType.CREATE_ALERT_DEVICE_DIALOG_FETCH_DATA_READY:
      return state.set("dialogData", action.payload);

    default:
      return state;
  }

}







